/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermsDto } from '../../models/terms-dto';

export interface TermsControllerGetHistoryByType$Params {
  type: 'SERVICE' | 'PRIVACY' | 'INVESTMENT' | 'THIRD_PARTY' | 'MARKETING' | 'ASSET';
}

export function termsControllerGetHistoryByType(http: HttpClient, rootUrl: string, params: TermsControllerGetHistoryByType$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TermsDto>>> {
  const rb = new RequestBuilder(rootUrl, termsControllerGetHistoryByType.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TermsDto>>;
    })
  );
}

termsControllerGetHistoryByType.PATH = '/api/terms/{type}/history';
